<template>
	<div class="menu-container">
		<v-btn
			v-if="$vuetify.breakpoint.mdAndUp"
			elevation="0"
			color="transparent"
			class="mr-2 white--text"
			@click="ui.show = !ui.show"
		>
			<small>
				Productos
			</small>

			<v-icon class="white--text">
				mdi-chevron-down
			</v-icon>
		</v-btn>

		<div
			class="menu-content elevation-8 animate__animated animate__fadeIn animate__faster"
			v-if="ui.show"
		>
			<div
				v-for="(category1, key1) in getParentCategories"
				:class="[
					'option',
					'd-flex',
					category1.categories.length
						? 'justify-space-between'
						: 'justify-end',
				]"
			>
				<template v-if="category1.categories.length">
					<v-icon class="white--text">
						mdi-chevron-left
					</v-icon>

					<div
						:class="[
							'menu',
							'elevation-8',
							'animate__animated',
							'animate__fadeIn',
							'animate__faster',
							startFormTop(getParentCategories.length, key1)
								? 'menu-from-top'
								: 'menu-from-bottom',
						]"
					>
						<div
							v-for="(category2, key2) in category1.categories"
							:class="[
								'option',
								'd-flex',
								category2.categories.length
									? 'justify-space-between'
									: 'justify-end',
							]"
						>
							<template v-if="category2.categories.length">
								<v-icon class="white--text">
									mdi-chevron-left
								</v-icon>

								<div
									:class="[
										'menu',
										'elevation-8',
										'animate__animated',
										'animate__fadeIn',
										'animate__faster',
										startFormTop(
											category2.categories.length,
											key2
										)
											? 'menu-from-top'
											: 'menu-from-bottom',
									]"
								>
									<div
										v-for="category2 in category2.categories"
										:class="[
											'option',
											'd-flex',
											category2.categories.length
												? 'justify-space-between'
												: 'justify-end',
										]"
									>
										{{ category2.name }}
									</div>
								</div>
							</template>
							{{ category2.name }}
						</div>
					</div>
				</template>
				{{ category1.name }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/main";

export default {
	data() {
		return {
			categories: [],

			categoryActive: {},

			ui: {
				show: false,
			},
		};
	},

	created() {
		EventBus.$on("MenuToggle", (data) => {
			if (data.name === "products_vertical") {
				this.ui.show = !this.ui.show;
			}
		});

		this.get();
	},

	methods: {
		async get() {
			await this.$store.dispatch("getCategories");

			this.categories.push({
				name: "productos",
				categories: this.getParentCategories,
			});
		},

		startFormTop(length, key) {
			if (key > length / 2) {
				return false;
			}

			return true;
		},
	},

	computed: {
		...mapGetters({
			getParentCategories: "getParentCategories",
		}),
	},
};
</script>

<style lang="css" scoped>
.menu-container {
	position: relative;
	display: flex;
	align-items: center;
}

.menu-content {
	position: absolute;
	display: flex;
	flex-direction: column;
	top: 100%;
	right: 0;
	font-size: 12px;
}

.option {
	position: relative;
	align-items: center;
	padding: 10px;
	color: #fff;
	cursor: pointer;
	text-align: right;
	height: 40px;
	min-width: 200px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	transition: all 0.3s;
	background-color: #333;
}

.menu {
	position: absolute;
	display: none;
	flex-direction: column;
	right: 100%;
}

.option:hover {
	background-color: #666;
	padding-right: 15px;
	padding-left: 5px;
}

.option:hover > .menu {
	display: flex;
}
.menu-from-top {
	top: 0;
}

.menu-from-bottom {
	bottom: 0;
}
</style>
